import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from '../css/Invoice.module.css';
import { FaArrowLeft } from 'react-icons/fa6';
import { FaTrash } from 'react-icons/fa';

const Invoice = () => {
	const { order_number } = useParams();
	const [invoices, setInvoices] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [selectedInvoice, setSelectedInvoice] = useState(null);

	const navigate = useNavigate();

	useEffect(() => {
		fetchInvoices();
	}, [order_number]);

	const fetchInvoices = async () => {
		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/FetchInvoice.php?booking_id=${order_number}`
			);
			const data = await response.json();
			setInvoices(data.status ? data.data : []);
		} catch (error) {
			console.error('Error fetching invoice:', error);
		} finally {
			setLoading(false);
		}
	};

	const updatePaymentStatus = async (invoiceId, currentStatus) => {
		const newStatus = currentStatus === 'paid' ? 'unpaid' : 'paid';

		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/UpdatePaymentStatus.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						invoice_id: invoiceId,
						payment_status: newStatus,
					}),
				}
			);
			const result = await response.json();

			if (result.status) {
				setError(`Payment marked as ${newStatus}`);
				fetchInvoices();
			} else {
				setError(`Error: ${result.msg}`);
			}
		} catch (error) {
			setError('Failed to update payment status');
		}
	};

	const confirmDelete = (invoiceId) => {
		setSelectedInvoice(invoiceId);
		setShowModal(true);
	};

	const deleteInvoice = async () => {
		if (!selectedInvoice) return;
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/deleteInvoice.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ invoice_id: selectedInvoice }),
				}
			);
			const result = await response.json();

			if (result.status) {
				setError('Invoice deleted successfully');
				fetchInvoices();
			} else {
				setError(`Error: ${result.msg}`);
			}
		} catch (error) {
			setError('Failed to delete invoice');
		}
		setShowModal(false);
		setSelectedInvoice(null);
	};

	const totalAmount = invoices.reduce(
		(sum, invoice) => sum + parseFloat(invoice.amount),
		0
	);

	if (loading) {
		return <div className={styles.loader}>Loading...</div>;
	}

	if (invoices.length === 0) {
		return (
			<div className={styles.noData}>
				<button onClick={() => navigate(-1)} className={styles.backButton}>
					<FaArrowLeft size={20} color="black" />
				</button>
				<p>No invoices found.</p>
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<button onClick={() => navigate(-1)} className={styles.backButton}>
				<FaArrowLeft size={20} color="black" />
			</button>
			<h2 className={styles.heading}>Order #: {order_number}</h2>
			<p>{error}</p>
			{invoices.map((item, index) => (
				<div key={index} className={styles.invoiceItem}>
					<button
						className={styles.deleteButton}
						onClick={() => confirmDelete(item.id)}
					>
						<FaTrash size={20} color="red" />
					</button>
					<p>
						<span>Date:</span> {item.date}
						{/* <span>Date:</span> {item.id} */}
					</p>
					<p>
						<span>Description:</span> {item.description}
					</p>
					<p>
						<span>Quantity:</span> {item.qty}
					</p>
					<p>
						<span>Amount:</span> ₹{item.amount}
					</p>
					<p>
						<span>Payment Method:</span> {item.payment_method}
					</p>
				</div>
			))}
			{showModal && (
				<div className={styles.modal}>
					<p>Are you sure you want to delete this invoice?</p>
					<button onClick={deleteInvoice} className={styles.confirmButton}>
						Yes
					</button>
					<button
						onClick={() => setShowModal(false)}
						className={styles.cancelButton}
					>
						No
					</button>
				</div>
			)}
		</div>
	);
};

export default Invoice;
